import { Component, OnInit, ViewChild, ViewContainerRef, ComponentRef } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { DisplayMenu, LogicData } from './displayMenu';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';

const NODE_TYPE = 'displayMenu';

@Component({
    selector: 'app-display-menu',
    templateUrl: './display-menu.component.html',
    styleUrls: ['./display-menu.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, ClickatellFormValidationComponent, ActiveFormDirective, MatSlideToggle, CMSComponent]
})
export class DisplayMenuComponent extends NodeBuilder implements OnInit {

  displayMenuForm: UntypedFormGroup;
  logicForm: UntypedFormGroup;

  @ViewChild('nextSelectorContainer', { read: ViewContainerRef }) nextSelectorContainer: ViewContainerRef;
  private nextSelectorRef: ComponentRef<any>;
  private nextStep;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: { [index: string]: any }) {
    const displayMenuForm = DisplayMenu.toForm(stepData, this.canEdit);
    this.displayMenuForm = displayMenuForm.DisplayMenuForm;
    this.logicForm = displayMenuForm.LogicForm;
    this.nextStep = 'step' + this.getNextStep();

    if (this.logicForm && this.logicForm.get('next').value === newStepValue) {
      this.logicForm.get('next').setValue(this.nextStep);
    }

    if (this.logicForm && !this.displayMenuForm.get('endSession').value) {
      this.createNextSelector();
    }
  }

  get getStepData(): {} {
    const formData = this.displayMenuForm.getRawValue();
    const logicData = this.logicForm?.getRawValue();
    const displayMenu = new DisplayMenu(formData, logicData);
    return displayMenu.nodeData(logicData?.next);
  }

  get isNodeValid(): boolean {
    this.displayMenuForm.markAllAsTouched();
    return this.displayMenuForm.valid;
  }

  private async createNextSelector(): Promise<void> {
    setTimeout(async () => {
      const { NextSelectorComponent } = await import('../../../../json-to-from/next-selector/next-selector.component');
      this.nextSelectorContainer.clear();
      this.nextSelectorRef = this.nextSelectorContainer.createComponent(NextSelectorComponent);
      this.nextSelectorRef.setInput('canEditFlows', this.canEdit.canEditFlows);
      this.nextSelectorRef.setInput('selectorType', 'both');
      this.nextSelectorRef.setInput('flowSteps', this.nodeFlowDetails.currentFlowSteps);
      this.nextSelectorRef.setInput('flows', this.nodeFlowDetails.flows);
      this.nextSelectorRef.setInput('name', 'next');
      this.nextSelectorRef.setInput('form', this.logicForm);
      this.nextSelectorRef.setInput('stepId', this.nodeFlowDetails.stepId);
    }, 0);
  }

  public async sessionEndToggle(slider): Promise<void> {
    if (slider.checked) {
      this.logicForm = null;
      if (this.nextSelectorRef) {
        this.nextSelectorRef.destroy();
      }
    } else {
      const logicData: LogicData = { next: this.nextStep };
      this.logicForm = DisplayMenu.buildLogicForm(logicData, { text: '', endSession: false }, this.canEdit.canEdit);
      this.createNextSelector();
    }
  }
}
